import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { Account } from './account'

export class AccountsRepository extends BaseRepository<Account> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.financialApiUrl + '/accounts', token, cache)
    }

    async getIntegrationToken(accountId: string, pluggyId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.financialApiUrl +
                '/accounts/integration/token?pluggyId=' +
                (pluggyId || '') +
                '&accountId=' +
                accountId +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async integrationLink(accountId: string, pluggyId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.financialApiUrl +
                '/accounts/integration/link?pluggyId=' +
                pluggyId +
                '&accountId=' +
                accountId +
                '&token=' +
                this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async integrationUnlink(accountId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.financialApiUrl +
                '/accounts/integration/unlink?accountId=' +
                accountId +
                '&token=' +
                this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async integrationGetTransactions(accountId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.financialApiUrl +
                '/accounts/integration/transactions?accountId=' +
                accountId +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
